/**
 * @type {Object} File extensions keyed by file category.
 */
export const EXTENSIONS_BY_CATEGORY = {
  ARCHIVE: ['RAR', 'TAR', 'ZIP'],
  AUDIO: ['FLAC', 'M4A', 'MP3', 'WAV'],
  DEFAULT: [],
  EXCEL: ['CSV', 'XLS', 'XLSX'],
  HTML: ['HTM', 'HTML'],
  ILLUSTRATOR: ['AI', 'EPS'],
  IMAGE: ['BMP', 'GIF', 'JPEG', 'JPG', 'PNG', 'SVG', 'TIF', 'TIFF', 'WEBP'],
  PDF: ['PDF'],
  PHOTOSHOP: ['PSB', 'PSD'],
  POWERPOINT: ['PPT', 'PPTX'],
  TEXT: ['RTF', 'TXT'],
  VIDEO: ['AVI', 'FLV', 'M4V', 'MKV', 'MOV', 'MP4', 'WEBM', 'WMV'],
  WORD: ['DOC', 'DOCX'],
};

/**
 * @type {Object} File categories keyed by file extension.
 */
export const CATEGORIES_BY_EXTENSION = (function getCategoriesByExtension(extensionsByCategory) {
  const categoriesByExtension = {};

  Object.keys(extensionsByCategory).forEach((category) => {
    extensionsByCategory[category].forEach((extension) => {
      categoriesByExtension[extension] = category;
    });
  });

  return categoriesByExtension;
})(EXTENSIONS_BY_CATEGORY);

/**
 * @type {Number} The maximum allowable file size in gigabytes.
 */
export const MAX_FILE_SIZE_IN_GB = 1;

/**
 * @type {Number} The maximum allowable file size in bytes.
 */
export const MAX_FILE_SIZE_IN_B = MAX_FILE_SIZE_IN_GB * (2 ** 30);

/**
 * @type {Number} The maximum allowable assets per message.
 */
export const MAX_ASSETS_PER_MESSAGE = 5;

/**
 * @type {Number} The number, from 0 to 100, that represents upload completion in the progress that
 * is displayed to the user. For example, if this is set to 90, when the actual percentage is 100%,
 * the user will see the progress bar only 90% filled. The remaining 10% is used for simulating the
 * progress of the file processing.
 */
export const UPLOAD_COMPLETE_PERCENTAGE = 80;
